module.exports = __webpack_public_path__ + "img/05.abb48b1a.png";